<template>
  <div class="min-h-screen bg-white relative">
    <!-- Header Component -->
    <SiteHeader 
      :currentSite="'main'" 
      :activeSection="activeSection"
      @toggleMobileMenu="handleToggleMobileMenu"
      @openContactModal="handleOpenContactModal"
      @openLoginModal="handleOpenLoginModal"
      @smoothScrollTo="handleSmoothScrollTo"
    />


    <!-- Header Banner Slider -->
    <section id="home" class="relative overflow-hidden">
      <!-- Slide Container -->
      <div 
        class="slide-container" 
        @mouseenter="stopAutoSlide" 
        @mouseleave="startAutoSlide"
      >
        <!-- Slide 1 -->
        <div class="slide relative" :class="{ 'active': currentSlideIndex === 0 }">
          <!-- Full Image Background -->
          <img src="https://vue-project.sgp1.digitaloceanspaces.com/https://vue-project.sgp1.digitaloceanspaces.com/2025/11/1762877017022.jpg" 
               alt="เครือข่ายธุรกิจชุมชน" 
               class="absolute inset-0 w-full h-full object-cover"
               loading="eager">
          
          <!-- Gradient Overlay for Text Readability -->
          <div class="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
          
          <!-- Text Overlay at Bottom -->
          <div class="absolute bottom-0 left-0 right-0 p-8 md:p-12 z-20">
            <div class="container mx-auto">
              <h1 class="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight text-white drop-shadow-2xl">
                เครือข่าย<span class="text-green-400">ธุรกิจชุมชน</span> 
                <span class="block text-2xl md:text-3xl text-gray-200 mt-2">(Cluster)</span>
              </h1>
              <p class="text-base md:text-lg lg:text-xl mb-6 leading-relaxed text-gray-100 max-w-3xl drop-shadow-lg">
                พัฒนาแนวคิด <span class="font-semibold text-green-300">Social Integrated Enterprise (SIE)</span> 
                เชื่อมโยงชุมชน ภาคการศึกษา และภาคธุรกิจ เพื่อยกระดับเศรษฐกิจฐานราก
              </p>
              <button class="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-8 py-3 md:px-10 md:py-4 rounded-xl font-semibold transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105">
                เรียนรู้เพิ่มเติม
              </button>
            </div>
          </div>
        </div>

        <!-- Slide 2 -->
        <div class="slide relative" :class="{ 'active': currentSlideIndex === 1 }">
          <!-- Full Image Background -->
          <img src="https://vue-project.sgp1.digitaloceanspaces.com/2025/11/1762875228773.jpg" 
               alt="ทรัพยากรท้องถิ่น" 
               class="absolute inset-0 w-full h-full object-cover"
               loading="eager">
          
          <!-- Gradient Overlay for Text Readability -->
          <div class="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
          
          <!-- Text Overlay at Bottom -->
          <div class="absolute bottom-0 left-0 right-0 p-8 md:p-12 z-20">
            <div class="container mx-auto">
              <h1 class="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight text-white drop-shadow-2xl">
                ใช้ทรัพยากร<span class="text-blue-400">ท้องถิ่น</span>
                <span class="block text-2xl md:text-3xl text-gray-200 mt-2">(Local Content)</span>
              </h1>
              <p class="text-base md:text-lg lg:text-xl mb-6 leading-relaxed text-gray-100 max-w-3xl drop-shadow-lg">
                ยกระดับคุณค่าและสร้างนวัตกรรมที่มี<span class="font-semibold text-blue-300">อัตลักษณ์</span> 
                โดยกระจายบทบาทและการมีส่วนร่วมจากทุกภาคส่วน
              </p>
              <button class="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white px-8 py-3 md:px-10 md:py-4 rounded-xl font-semibold transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105">
                ดูรายละเอียด
              </button>
            </div>
          </div>
        </div>

        <!-- Slide 3 -->
        <div class="slide relative" :class="{ 'active': currentSlideIndex === 2 }">
          <!-- Full Image Background -->
          <img src="https://vue-project.sgp1.digitaloceanspaces.com/https://vue-project.sgp1.digitaloceanspaces.com/2025/11/1762877018956.jpg" 
               alt="ศูนย์การเรียนรู้" 
               class="absolute inset-0 w-full h-full object-cover"
               loading="eager">
          
          <!-- Gradient Overlay for Text Readability -->
          <div class="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
          
          <!-- Text Overlay at Bottom -->
          <div class="absolute bottom-0 left-0 right-0 p-8 md:p-12 z-20">
            <div class="container mx-auto">
              <h1 class="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight text-white drop-shadow-2xl">
                ศูนย์เรียนรู้และพัฒนา<br>
                <span class="text-purple-400">เครือข่ายนวัตกรรม</span>
              </h1>
              <p class="text-base md:text-lg lg:text-xl mb-6 leading-relaxed text-gray-100 max-w-3xl drop-shadow-lg">
                บูรณาการองค์ความรู้จาก<span class="font-semibold text-purple-300">ภาคการศึกษา ภาคธุรกิจ และภาคประชาชน</span> 
                เพื่อพัฒนานวัตกรรมในกระบวนการผลิตและการตลาด
              </p>
              <button class="bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white px-8 py-3 md:px-10 md:py-4 rounded-xl font-semibold transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105">
                เข้าร่วมเครือข่าย
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Navigation Dots -->
      <div class="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2 z-10">
        <button 
          class="dot w-3 h-3 rounded-full bg-white transition-all duration-300"
          :class="currentSlideIndex === 0 ? 'opacity-80 scale-125' : 'opacity-50'"
          @click="goToSlide(0)"
          aria-label="Go to slide 1"
        ></button>
        <button 
          class="dot w-3 h-3 rounded-full bg-white transition-all duration-300"
          :class="currentSlideIndex === 1 ? 'opacity-80 scale-125' : 'opacity-50'"
          @click="goToSlide(1)"
          aria-label="Go to slide 2"
        ></button>
        <button 
          class="dot w-3 h-3 rounded-full bg-white transition-all duration-300"
          :class="currentSlideIndex === 2 ? 'opacity-80 scale-125' : 'opacity-50'"
          @click="goToSlide(2)"
          aria-label="Go to slide 3"
        ></button>
      </div>

      <!-- Navigation Arrows -->
      <button 
        class="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-20 hover:bg-opacity-30 text-white p-2 rounded-full transition-all z-10" 
        id="prevBtn"
        @click="handlePrevSlide"
        aria-label="Previous slide"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
        </svg>
      </button>
      <button 
        class="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-20 hover:bg-opacity-30 text-white p-2 rounded-full transition-all z-10" 
        id="nextBtn"
        @click="handleNextSlide"
        aria-label="Next slide"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
        </svg>
      </button>
    </section>

    <!-- Dashboard Report Section -->
    <section id="dashboard" class="py-16 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-12">
          <h3 class="text-4xl font-bold text-gray-900 mb-4">ผลการดำเนินงานคลัสเตอร์ทั้งหมด</h3>
          <p class="text-lg text-gray-600">รายได้และมูลค่าเพิ่มที่เกิดขึ้นในโครงสร้างเครือข่ายแต่ละคลัสเตอร์</p>
        </div>

        <!-- Main Stats Cards -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          <!-- Total Users -->
          <div class="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-300">
            <div class="flex items-center justify-between mb-4">
              <div class="p-3 bg-blue-100 rounded-xl">
                <svg class="w-8 h-8 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"/>
                </svg>
              </div>
              <div class="text-right">
                <div class="flex items-center text-green-600 text-sm font-medium">
                  <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
                  </svg>
                  +12.5%
                </div>
              </div>
            </div>
            <div>
              <h4 class="text-3xl font-bold text-gray-900 mb-1">6</h4>
              <p class="text-gray-600 text-sm font-medium">คลัสเตอร์ที่เปิดดำเนินการ</p>
              <p class="text-xs text-gray-500 mt-1">กาแฟ ประมง ผลไม้ มะระ ฮาลาล หม่อนไหม</p>
            </div>
          </div>

          <!-- Active Projects -->
          <div class="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-300">
            <div class="flex items-center justify-between mb-4">
              <div class="p-3 bg-green-100 rounded-xl">
                <svg class="w-8 h-8 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"/>
                </svg>
              </div>
              <div class="text-right">
                <div class="flex items-center text-green-600 text-sm font-medium">
                  <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
                  </svg>
                  +8.2%
                </div>
              </div>
            </div>
            <div>
              <h4 class="text-3xl font-bold text-gray-900 mb-1">342</h4>
              <p class="text-gray-600 text-sm font-medium">ชุมชนในเครือข่าย</p>
              <p class="text-xs text-gray-500 mt-1">ชุมชนที่เข้าร่วมในทุกคลัสเตอร์</p>
            </div>
          </div>

          <!-- Revenue -->
          <!-- <div class="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-300">
            <div class="flex items-center justify-between mb-4">
              <div class="p-3 bg-purple-100 rounded-xl">
                <svg class="w-8 h-8 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z"/>
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z" clip-rule="evenodd"/>
                </svg>
              </div>
              <div class="text-right">
                <div class="flex items-center text-green-600 text-sm font-medium">
                  <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
                  </svg>
                  +15.8%
                </div>
              </div>
            </div>
            <div>
              <h4 class="text-3xl font-bold text-gray-900 mb-1">฿1.2B</h4>
              <p class="text-gray-600 text-sm font-medium">รายได้รวมทุกคลัสเตอร์</p>
              <p class="text-xs text-gray-500 mt-1">รายได้ที่เกิดขึ้นในเครือข่าย</p>
            </div>
          </div> -->

          <!-- Success Rate -->
          <div class="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-300">
            <div class="flex items-center justify-between mb-4">
              <div class="p-3 bg-orange-100 rounded-xl">
                <svg class="w-8 h-8 text-orange-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                </svg>
              </div>
              <div class="text-right">
                <div class="flex items-center text-green-600 text-sm font-medium">
                  <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
                  </svg>
                  +2.1%
                </div>
              </div>
            </div>
            <div>
              <h4 class="text-3xl font-bold text-gray-900 mb-1">85%</h4>
              <p class="text-gray-600 text-sm font-medium">การใช้ทรัพยากรหมุนเวียน</p>
              <p class="text-xs text-gray-500 mt-1">ประสิทธิภาพเศรษฐกิจหมุนเวียน</p>
            </div>
          </div>
        </div>

        <!-- Charts Section -->
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
          <!-- Performance Chart -->
          <div class="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
            <div class="flex items-center justify-between mb-8">
              <h4 class="text-2xl font-semibold text-gray-900">รายได้รายคลัสเตอร์</h4>
              <select class="border border-gray-200 rounded-xl px-4 py-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-blue-500">
                <option>7 วันที่ผ่านมา</option>
                <option>30 วันที่ผ่านมา</option>
                <option>3 เดือนที่ผ่านมา</option>
              </select>
            </div>
            
            <!-- Enhanced Chart -->
            <div class="relative h-80">
              <div class="absolute inset-0 flex items-end justify-around px-6 pb-12">
                <div class="flex flex-col items-center">
                  <div class="bg-blue-500 rounded-t-xl hover:bg-blue-600 transition-colors cursor-pointer shadow-lg" style="height: 180px; width: 32px;" title="กาแฟ: ฿280M"></div>
                  <span class="text-xs text-gray-600 mt-3 font-medium">กาแฟ</span>
                </div>
                <div class="flex flex-col items-center">
                  <div class="bg-green-500 rounded-t-xl hover:bg-green-600 transition-colors cursor-pointer shadow-lg" style="height: 240px; width: 32px;" title="ประมง: ฿320M"></div>
                  <span class="text-xs text-gray-600 mt-3 font-medium">ประมง</span>
                </div>
                <div class="flex flex-col items-center">
                  <div class="bg-purple-500 rounded-t-xl hover:bg-purple-600 transition-colors cursor-pointer shadow-lg" style="height: 135px; width: 32px;" title="ผลไม้: ฿185M"></div>
                  <span class="text-xs text-gray-600 mt-3 font-medium">ผลไม้</span>
                </div>
                <div class="flex flex-col items-center">
                  <div class="bg-orange-500 rounded-t-xl hover:bg-orange-600 transition-colors cursor-pointer shadow-lg" style="height: 270px; width: 32px;" title="มะระ: ฿125M"></div>
                  <span class="text-xs text-gray-600 mt-3 font-medium">มะระ</span>
                </div>
                <div class="flex flex-col items-center">
                  <div class="bg-red-500 rounded-t-xl hover:bg-red-600 transition-colors cursor-pointer shadow-lg" style="height: 195px; width: 32px;" title="ฮาลาล: ฿198M"></div>
                  <span class="text-xs text-gray-600 mt-3 font-medium">ฮาลาล</span>
                </div>
                <div class="flex flex-col items-center">
                  <div class="bg-teal-500 rounded-t-xl hover:bg-teal-600 transition-colors cursor-pointer shadow-lg" style="height: 225px; width: 32px;" title="หม่อนไหม: ฿158M"></div>
                  <span class="text-xs text-gray-600 mt-3 font-medium">หม่อน</span>
                </div>
                <div class="flex flex-col items-center">
                  <div class="bg-indigo-500 rounded-t-xl hover:bg-indigo-600 transition-colors cursor-pointer shadow-lg" style="height: 165px; width: 32px;" title="ท่องเที่ยว: ฿142M"></div>
                  <span class="text-xs text-gray-600 mt-3 font-medium">ท่องเที่ยว</span>
                </div>
              </div>
              
              <!-- Y-axis labels -->
              <div class="absolute left-0 top-0 h-full flex flex-col justify-between py-4 text-xs text-gray-500 font-medium">
                <span>100%</span>
                <span>75%</span>
                <span>50%</span>
                <span>25%</span>
                <span>0%</span>
              </div>
              
              <!-- Grid lines -->
              <div class="absolute inset-0 pointer-events-none">
                <div class="h-full w-full relative">
                  <div class="absolute top-0 left-8 right-0 h-px bg-gray-200"></div>
                  <div class="absolute top-1/4 left-8 right-0 h-px bg-gray-200"></div>
                  <div class="absolute top-1/2 left-8 right-0 h-px bg-gray-200"></div>
                  <div class="absolute top-3/4 left-8 right-0 h-px bg-gray-200"></div>
                  <div class="absolute bottom-12 left-8 right-0 h-px bg-gray-300"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- Usage Analytics -->
          <div class="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
            <div class="flex items-center justify-between mb-8">
              <h4 class="text-2xl font-semibold text-gray-900">การมีส่วนร่วมของภาคส่วน</h4>
              <span class="text-sm text-gray-500 bg-gray-100 px-3 py-1 rounded-full">อัปเดตล่าสุด: เมื่อ 5 นาทีที่แล้ว</span>
            </div>
            
            <!-- Enhanced Feature Usage List -->
            <div class="space-y-6">
              <div class="relative">
                <div class="flex items-center justify-between mb-2">
                  <div class="flex items-center">
                    <div class="w-4 h-4 bg-blue-500 rounded-full mr-3 shadow-sm"></div>
                    <span class="text-gray-800 font-medium">ภาคการศึกษา</span>
                  </div>
                  <span class="text-lg font-bold text-gray-900">80%</span>
                </div>
                <div class="w-full h-3 bg-gray-200 rounded-full overflow-hidden">
                  <div class="h-full bg-gradient-to-r from-blue-400 to-blue-500 rounded-full shadow-sm transition-all duration-1000 ease-out" style="width: 80%"></div>
                </div>
              </div>
              
              <div class="relative">
                <div class="flex items-center justify-between mb-2">
                  <div class="flex items-center">
                    <div class="w-4 h-4 bg-green-500 rounded-full mr-3 shadow-sm"></div>
                    <span class="text-gray-800 font-medium">ภาคธุรกิจ</span>
                  </div>
                  <span class="text-lg font-bold text-gray-900">65%</span>
                </div>
                <div class="w-full h-3 bg-gray-200 rounded-full overflow-hidden">
                  <div class="h-full bg-gradient-to-r from-green-400 to-green-500 rounded-full shadow-sm transition-all duration-1000 ease-out" style="width: 65%"></div>
                </div>
              </div>
              
              <div class="relative">
                <div class="flex items-center justify-between mb-2">
                  <div class="flex items-center">
                    <div class="w-4 h-4 bg-purple-500 rounded-full mr-3 shadow-sm"></div>
                    <span class="text-gray-800 font-medium">ภาคชุมชน</span>
                  </div>
                  <span class="text-lg font-bold text-gray-900">55%</span>
                </div>
                <div class="w-full h-3 bg-gray-200 rounded-full overflow-hidden">
                  <div class="h-full bg-gradient-to-r from-purple-400 to-purple-500 rounded-full shadow-sm transition-all duration-1000 ease-out" style="width: 55%"></div>
                </div>
              </div>
              
              <div class="relative">
                <div class="flex items-center justify-between mb-2">
                  <div class="flex items-center">
                    <div class="w-4 h-4 bg-orange-500 rounded-full mr-3 shadow-sm"></div>
                    <span class="text-gray-800 font-medium">ภาคราชการ</span>
                  </div>
                  <span class="text-lg font-bold text-gray-900">45%</span>
                </div>
                <div class="w-full h-3 bg-gray-200 rounded-full overflow-hidden">
                  <div class="h-full bg-gradient-to-r from-orange-400 to-orange-500 rounded-full shadow-sm transition-all duration-1000 ease-out" style="width: 45%"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Additional Data Visualizations -->
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">
          <!-- Pie Chart -->
          <div class="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
            <div class="text-center mb-6">
              <h4 class="text-xl font-semibold text-gray-900 mb-2">การกระจายผู้ใช้</h4>
              <p class="text-sm text-gray-600">แบ่งตามประเภทผู้ใช้งาน</p>
            </div>
            
            <!-- Mock Pie Chart -->
            <div class="relative w-48 h-48 mx-auto mb-6">
              <svg class="w-full h-full transform -rotate-90" viewBox="0 0 100 100">
                <!-- Background circle -->
                <circle cx="50" cy="50" r="45" fill="none" stroke="#f3f4f6" stroke-width="10"/>
                
                <!-- Blue segment (45%) -->
                <circle cx="50" cy="50" r="45" fill="none" stroke="#3b82f6" stroke-width="10"
                        stroke-dasharray="127 283" stroke-dashoffset="0" class="transition-all duration-1000"/>
                
                <!-- Green segment (30%) -->
                <circle cx="50" cy="50" r="45" fill="none" stroke="#10b981" stroke-width="10"
                        stroke-dasharray="85 325" stroke-dashoffset="-127" class="transition-all duration-1000"/>
                
                <!-- Purple segment (25%) -->
                <circle cx="50" cy="50" r="45" fill="none" stroke="#8b5cf6" stroke-width="10"
                        stroke-dasharray="70 340" stroke-dashoffset="-212" class="transition-all duration-1000"/>
              </svg>
              
              <!-- Center text -->
              <div class="absolute inset-0 flex items-center justify-center">
                <div class="text-center">
                  <div class="text-2xl font-bold text-gray-900">1,247</div>
                  <div class="text-xs text-gray-600">ผู้ใช้ออนไลน์</div>
                </div>
              </div>
            </div>
            
            <!-- Legend -->
            <div class="space-y-3">
              <div class="flex items-center justify-between">
                <div class="flex items-center">
                  <div class="w-3 h-3 bg-blue-500 rounded-full mr-2"></div>
                  <span class="text-sm text-gray-700">ผู้ดูแลระบบ</span>
                </div>
                <span class="text-sm font-medium text-gray-900">45%</span>
              </div>
              <div class="flex items-center justify-between">
                <div class="flex items-center">
                  <div class="w-3 h-3 bg-green-500 rounded-full mr-2"></div>
                  <span class="text-sm text-gray-700">ผู้ใช้ทั่วไป</span>
                </div>
                <span class="text-sm font-medium text-gray-900">30%</span>
              </div>
              <div class="flex items-center justify-between">
                <div class="flex items-center">
                  <div class="w-3 h-3 bg-purple-500 rounded-full mr-2"></div>
                  <span class="text-sm text-gray-700">ผู้เยี่ยมชม</span>
                </div>
                <span class="text-sm font-medium text-gray-900">25%</span>
              </div>
            </div>
          </div>

          <!-- Activity Timeline -->
          <div class="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
            <div class="mb-6">
              <h4 class="text-xl font-semibold text-gray-900 mb-2">กิจกรรมล่าสุด</h4>
              <p class="text-sm text-gray-600">อัปเดตแบบเรียลไทม์</p>
            </div>
            
            <div class="space-y-4">
              <div class="flex items-start space-x-3">
                <div class="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></div>
                <div class="flex-1 min-w-0">
                  <p class="text-sm font-medium text-gray-900">โปรเจกต์ใหม่ถูกสร้าง</p>
                  <p class="text-xs text-gray-500">2 นาทีที่แล้ว</p>
                </div>
              </div>
              
              <div class="flex items-start space-x-3">
                <div class="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                <div class="flex-1 min-w-0">
                  <p class="text-sm font-medium text-gray-900">ผู้ใช้ใหม่ลงทะเบียน</p>
                  <p class="text-xs text-gray-500">5 นาทีที่แล้ว</p>
                </div>
              </div>
              
              <div class="flex items-start space-x-3">
                <div class="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></div>
                <div class="flex-1 min-w-0">
                  <p class="text-sm font-medium text-gray-900">รายงานถูกส่งออก</p>
                  <p class="text-xs text-gray-500">10 นาทีที่แล้ว</p>
                </div>
              </div>
              
              <div class="flex items-start space-x-3">
                <div class="w-2 h-2 bg-purple-500 rounded-full mt-2 flex-shrink-0"></div>
                <div class="flex-1 min-w-0">
                  <p class="text-sm font-medium text-gray-900">ข้อมูลถูกอัปเดต</p>
                  <p class="text-xs text-gray-500">15 นาทีที่แล้ว</p>
                </div>
              </div>
              
              <div class="flex items-start space-x-3">
                <div class="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></div>
                <div class="flex-1 min-w-0">
                  <p class="text-sm font-medium text-gray-900">การแจ้งเตือนใหม่</p>
                  <p class="text-xs text-gray-500">20 นาทีที่แล้ว</p>
                </div>
              </div>

              <div class="flex items-start space-x-3">
                <div class="w-2 h-2 bg-indigo-500 rounded-full mt-2 flex-shrink-0"></div>
                <div class="flex-1 min-w-0">
                  <p class="text-sm font-medium text-gray-900">การสำรองข้อมูลเสร็จสิ้น</p>
                  <p class="text-xs text-gray-500">25 นาทีที่แล้ว</p>
                </div>
              </div>
            </div>
            
            <button class="w-full mt-4 text-sm text-blue-600 hover:text-blue-700 font-medium">
              ดูกิจกรรมทั้งหมด →
            </button>
          </div>

          <!-- System Status -->
          <div class="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
            <div class="mb-6">
              <h4 class="text-xl font-semibold text-gray-900 mb-2">สถานะระบบ</h4>
              <p class="text-sm text-gray-600">การตรวจสอบสุขภาพระบบ</p>
            </div>
            
            <div class="space-y-4">
              <!-- Server Status -->
              <div class="flex items-center justify-between p-3 bg-green-50 rounded-lg">
                <div class="flex items-center">
                  <div class="w-3 h-3 bg-green-500 rounded-full mr-3"></div>
                  <span class="text-sm font-medium text-gray-900">เซิร์ฟเวอร์</span>
                </div>
                <span class="text-xs font-medium text-green-700 bg-green-100 px-2 py-1 rounded-full">ออนไลน์</span>
              </div>
              
              <!-- Database Status -->
              <div class="flex items-center justify-between p-3 bg-green-50 rounded-lg">
                <div class="flex items-center">
                  <div class="w-3 h-3 bg-green-500 rounded-full mr-3"></div>
                  <span class="text-sm font-medium text-gray-900">ฐานข้อมูล</span>
                </div>
                <span class="text-xs font-medium text-green-700 bg-green-100 px-2 py-1 rounded-full">ปกติ</span>
              </div>
              
              <!-- API Status -->
              <div class="flex items-center justify-between p-3 bg-yellow-50 rounded-lg">
                <div class="flex items-center">
                  <div class="w-3 h-3 bg-yellow-500 rounded-full mr-3"></div>
                  <span class="text-sm font-medium text-gray-900">API</span>
                </div>
                <span class="text-xs font-medium text-yellow-700 bg-yellow-100 px-2 py-1 rounded-full">ช้า</span>
              </div>
              
              <!-- Storage Status -->
              <div class="flex items-center justify-between p-3 bg-green-50 rounded-lg">
                <div class="flex items-center">
                  <div class="w-3 h-3 bg-green-500 rounded-full mr-3"></div>
                  <span class="text-sm font-medium text-gray-900">พื้นที่จัดเก็บ</span>
                </div>
                <span class="text-xs font-medium text-green-700 bg-green-100 px-2 py-1 rounded-full">68% ใช้งาน</span>
              </div>
            </div>
            
            <!-- System Metrics -->
            <div class="mt-6 pt-4 border-t border-gray-200">
              <div class="grid grid-cols-2 gap-4">
                <div class="text-center">
                  <div class="text-lg font-bold text-gray-900">99.9%</div>
                  <div class="text-xs text-gray-600">Uptime</div>
                </div>
                <div class="text-center">
                  <div class="text-lg font-bold text-gray-900">23ms</div>
                  <div class="text-xs text-gray-600">Response Time</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Quick Actions -->
        <!-- <div class="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
          <h4 class="text-2xl font-semibold text-gray-900 mb-6">การดำเนินการด่วน</h4>
          <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
            <button class="group flex flex-col items-center p-6 bg-gray-50 rounded-xl hover:bg-blue-50 hover:shadow-lg transition-all duration-300 border border-gray-100">
              <div class="p-4 bg-blue-100 rounded-xl mb-4 group-hover:bg-blue-200 transition-colors">
                <svg class="w-8 h-8 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"/>
                  <path fill-rule="evenodd" d="M4 5a2 2 0 012-2v1a1 1 0 001 1h6a1 1 0 001-1V3a2 2 0 012 2v6a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3z" clip-rule="evenodd"/>
                </svg>
              </div>
              <span class="text-sm font-semibold text-gray-700 group-hover:text-blue-700">สร้างโปรเจกต์</span>
            </button>
            
            <button class="group flex flex-col items-center p-6 bg-gray-50 rounded-xl hover:bg-green-50 hover:shadow-lg transition-all duration-300 border border-gray-100">
              <div class="p-4 bg-green-100 rounded-xl mb-4 group-hover:bg-green-200 transition-colors">
                <svg class="w-8 h-8 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                </svg>
              </div>
              <span class="text-sm font-semibold text-gray-700 group-hover:text-green-700">ดูรายงาน</span>
            </button>
            
            <button class="group flex flex-col items-center p-6 bg-gray-50 rounded-xl hover:bg-purple-50 hover:shadow-lg transition-all duration-300 border border-gray-100">
              <div class="p-4 bg-purple-100 rounded-xl mb-4 group-hover:bg-purple-200 transition-colors">
                <svg class="w-8 h-8 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3z"/>
                </svg>
              </div>
              <span class="text-sm font-semibold text-gray-700 group-hover:text-purple-700">จัดการทีม</span>
            </button>
            
            <button class="group flex flex-col items-center p-6 bg-gray-50 rounded-xl hover:bg-orange-50 hover:shadow-lg transition-all duration-300 border border-gray-100">
              <div class="p-4 bg-orange-100 rounded-xl mb-4 group-hover:bg-orange-200 transition-colors">
                <svg class="w-8 h-8 text-orange-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd"/>
                </svg>
              </div>
              <span class="text-sm font-semibold text-gray-700 group-hover:text-orange-700">ตั้งค่า</span>
            </button>
          </div>
        </div> -->
      </div>
    </section>

    <!-- Clusters Dashboard -->
    <section id="clusters" class="py-16 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-12">
          <h3 class="text-4xl font-bold text-gray-900 mb-4">คลัสเตอร์ทั้งหมด</h3>
          <p class="text-lg text-gray-600">ภาพรวมผลการดำเนินงานของแต่ละคลัสเตอร์</p>
        </div>
        
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <!-- Coffee Cluster -->
          <a href="https://coffee.clustersie.org" target="_blank" class="block bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-300">
            <div class="flex items-start justify-between mb-4">
              <div class="w-16 h-16 bg-gradient-to-br from-amber-100 to-orange-100 rounded-2xl flex items-center justify-center">
                <span class="text-2xl">☕</span>
              </div>
              <div class="text-right">
                <div class="text-xs text-gray-500 mb-1">รายได้เดือนนี้</div>
                <div class="text-lg font-bold text-green-600">฿280M</div>
              </div>
            </div>
            
            <!-- Information Section -->
            <div class="mb-4 pb-4 border-b border-gray-100">
              <h4 class="text-xl font-bold text-gray-900 mb-2">คลัสเตอร์กาแฟ</h4>
              <p class="text-sm text-gray-600">ระบบจัดการธุรกิจกาแฟครบวงจร</p>
            </div>
            
            <!-- Chart Section -->
            <div class="mb-4">
              <div class="grid grid-cols-3 gap-4">
                <!-- Bar Chart -->
                <div class="text-center">
                  <div class="flex items-end justify-center space-x-1 h-12 mb-1">
                    <div class="bg-amber-300 w-2 rounded-t" style="height: 60%"></div>
                    <div class="bg-amber-400 w-2 rounded-t" style="height: 80%"></div>
                    <div class="bg-amber-500 w-2 rounded-t" style="height: 100%"></div>
                    <div class="bg-orange-400 w-2 rounded-t" style="height: 75%"></div>
                    <div class="bg-orange-300 w-2 rounded-t" style="height: 65%"></div>
                  </div>
                  <div class="text-xs text-gray-400">ผลผลิตรายเดือน</div>
                </div>
                
                <!-- Circle Chart -->
                <div class="text-center">
                  <div class="relative w-12 h-12 mx-auto mb-1">
                    <svg class="w-12 h-12 transform -rotate-90" viewBox="0 0 36 36">
                      <path class="text-gray-200" stroke="currentColor" stroke-width="3" fill="none" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="text-amber-500" stroke="currentColor" stroke-width="3" fill="none" stroke-dasharray="87, 100" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    </svg>
                    <div class="absolute inset-0 flex items-center justify-center">
                      <span class="text-xs font-bold text-amber-600">87%</span>
                    </div>
                  </div>
                  <div class="text-xs text-gray-400">ประสิทธิภาพการผลิต</div>
                </div>
                
                <!-- Progress Bars -->
                <div class="text-center">
                  <div class="space-y-1 mb-1">
                    <div>
                      <div class="text-xs text-gray-500 mb-1">ปริมาณผลผลิต</div>
                      <div class="w-full bg-gray-200 rounded-full h-1">
                        <div class="bg-amber-500 h-1 rounded-full" style="width: 85%"></div>
                      </div>
                    </div>
                    <div>
                      <div class="text-xs text-gray-500 mb-1">คุณภาพสินค้า</div>
                      <div class="w-full bg-gray-200 rounded-full h-1">
                        <div class="bg-orange-500 h-1 rounded-full" style="width: 92%"></div>
                      </div>
                    </div>
                  </div>
                  <div class="text-xs text-gray-400">85%, 92%</div>
                </div>
              </div>
            </div>
            
            <!-- Stats Footer (3 Columns) -->
            <div class="grid grid-cols-3 gap-4 pt-3 border-t border-gray-100 text-center">
              <div>
                <div class="text-lg font-bold text-amber-600">45</div>
                <div class="text-xs text-gray-500">ชุมชน</div>
              </div>
              <div>
                <div class="text-lg font-bold text-amber-600">1,280</div>
                <div class="text-xs text-gray-500">สมาชิก</div>
              </div>
              <div>
                <div class="text-lg font-bold text-green-600">87%</div>
                <div class="text-xs text-gray-500">เป้าหมาย</div>
              </div>
            </div>
            
            <div class="text-amber-600 font-medium text-sm mt-4 text-center">เข้าใช้งาน →</div>
          </a>

          <!-- Fisheries Cluster -->
          <a href="https://fisheries.clustersie.org" target="_blank" class="block bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-300">
            <div class="flex items-start justify-between mb-4">
              <div class="w-16 h-16 bg-gradient-to-br from-blue-100 to-cyan-100 rounded-2xl flex items-center justify-center">
                <span class="text-2xl">🐟</span>
              </div>
              <div class="text-right">
                <div class="text-xs text-gray-500 mb-1">รายได้เดือนนี้</div>
                <div class="text-lg font-bold text-green-600">฿320M</div>
              </div>
            </div>
            
            <!-- Information Section -->
            <div class="mb-4 pb-4 border-b border-gray-100">
              <h4 class="text-xl font-bold text-gray-900 mb-2">คลัสเตอร์ประมง</h4>
              <p class="text-sm text-gray-600">จัดการธุรกิจประมงและผลิตภัณฑ์ทะเล</p>
            </div>
            
            <!-- Chart Section -->
            <div class="mb-4">
              <div class="grid grid-cols-3 gap-4">
                <!-- Bar Chart -->
                <div class="text-center">
                  <div class="flex items-end justify-center space-x-1 h-12 mb-1">
                    <div class="bg-blue-300 w-2 rounded-t" style="height: 70%"></div>
                    <div class="bg-blue-400 w-2 rounded-t" style="height: 85%"></div>
                    <div class="bg-blue-500 w-2 rounded-t" style="height: 100%"></div>
                    <div class="bg-cyan-400 w-2 rounded-t" style="height: 90%"></div>
                    <div class="bg-cyan-300 w-2 rounded-t" style="height: 75%"></div>
                  </div>
                  <div class="text-xs text-gray-400">ผลผลิตรายเดือน</div>
                </div>
                
                <!-- Circle Chart -->
                <div class="text-center">
                  <div class="relative w-12 h-12 mx-auto mb-1">
                    <svg class="w-12 h-12 transform -rotate-90" viewBox="0 0 36 36">
                      <path class="text-gray-200" stroke="currentColor" stroke-width="3" fill="none" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="text-blue-500" stroke="currentColor" stroke-width="3" fill="none" stroke-dasharray="92, 100" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    </svg>
                    <div class="absolute inset-0 flex items-center justify-center">
                      <span class="text-xs font-bold text-blue-600">92%</span>
                    </div>
                  </div>
                  <div class="text-xs text-gray-400">ประสิทธิภาพการผลิต</div>
                </div>
                
                <!-- Progress Bars -->
                <div class="text-center">
                  <div class="space-y-1 mb-1">
                    <div>
                      <div class="text-xs text-gray-500 mb-1">ปริมาณผลผลิต</div>
                      <div class="w-full bg-gray-200 rounded-full h-1">
                        <div class="bg-blue-500 h-1 rounded-full" style="width: 88%"></div>
                      </div>
                    </div>
                    <div>
                      <div class="text-xs text-gray-500 mb-1">คุณภาพสินค้า</div>
                      <div class="w-full bg-gray-200 rounded-full h-1">
                        <div class="bg-cyan-500 h-1 rounded-full" style="width: 94%"></div>
                      </div>
                    </div>
                  </div>
                  <div class="text-xs text-gray-400">88%, 94%</div>
                </div>
              </div>
            </div>
            
            <!-- Stats Footer (3 Columns) -->
            <div class="grid grid-cols-3 gap-4 pt-3 border-t border-gray-100 text-center">
              <div>
                <div class="text-lg font-bold text-blue-600">38</div>
                <div class="text-xs text-gray-500">ชุมชน</div>
              </div>
              <div>
                <div class="text-lg font-bold text-blue-600">950</div>
                <div class="text-xs text-gray-500">สมาชิก</div>
              </div>
              <div>
                <div class="text-lg font-bold text-cyan-600">24</div>
                <div class="text-xs text-gray-500">ผลิตภัณฑ์</div>
              </div>
            </div>
            
            <div class="text-blue-600 font-medium text-sm mt-4 text-center">เข้าใช้งาน →</div>
          </a>

          <!-- Fruit & Vegetable Cluster -->
          <a href="https://fruit.clustersie.org" target="_blank" class="block bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-300">
            <div class="flex items-start justify-between mb-4">
              <div class="w-16 h-16 bg-gradient-to-br from-green-100 to-emerald-100 rounded-2xl flex items-center justify-center">
                <span class="text-2xl">🍎</span>
              </div>
              <div class="text-right">
                <div class="text-xs text-gray-500 mb-1">รายได้เดือนนี้</div>
                <div class="text-lg font-bold text-green-600">฿185M</div>
              </div>
            </div>
            
            <!-- Information Section -->
            <div class="mb-4 pb-4 border-b border-gray-100">
              <h4 class="text-xl font-bold text-gray-900 mb-2">คลัสเตอร์ผักและผลไม้</h4>
              <p class="text-sm text-gray-600">ระบบจัดการผลิตผักและผลไม้</p>
            </div>
            
            <!-- Chart Section -->
            <div class="mb-4">
              <div class="grid grid-cols-3 gap-4">
                <!-- Bar Chart -->
                <div class="text-center">
                  <div class="flex items-end justify-center space-x-1 h-12 mb-1">
                    <div class="bg-green-300 w-2 rounded-t" style="height: 60%"></div>
                    <div class="bg-green-400 w-2 rounded-t" style="height: 80%"></div>
                    <div class="bg-green-500 w-2 rounded-t" style="height: 100%"></div>
                    <div class="bg-emerald-400 w-2 rounded-t" style="height: 75%"></div>
                    <div class="bg-emerald-300 w-2 rounded-t" style="height: 85%"></div>
                  </div>
                  <div class="text-xs text-gray-400">ผลผลิตรายเดือน</div>
                </div>
                
                <!-- Circle Chart -->
                <div class="text-center">
                  <div class="relative w-12 h-12 mx-auto mb-1">
                    <svg class="w-12 h-12 transform -rotate-90" viewBox="0 0 36 36">
                      <path class="text-gray-200" stroke="currentColor" stroke-width="3" fill="none" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="text-green-500" stroke="currentColor" stroke-width="3" fill="none" stroke-dasharray="85, 100" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    </svg>
                    <div class="absolute inset-0 flex items-center justify-center">
                      <span class="text-xs font-bold text-green-600">85%</span>
                    </div>
                  </div>
                  <div class="text-xs text-gray-400">ประสิทธิภาพการผลิต</div>
                </div>
                
                <!-- Progress Bars -->
                <div class="text-center">
                  <div class="space-y-1 mb-1">
                    <div>
                      <div class="text-xs text-gray-500 mb-1">ปริมาณผลผลิต</div>
                      <div class="w-full bg-gray-200 rounded-full h-1">
                        <div class="bg-green-500 h-1 rounded-full" style="width: 85%"></div>
                      </div>
                    </div>
                    <div>
                      <div class="text-xs text-gray-500 mb-1">คุณภาพสินค้า</div>
                      <div class="w-full bg-gray-200 rounded-full h-1">
                        <div class="bg-emerald-500 h-1 rounded-full" style="width: 92%"></div>
                      </div>
                    </div>
                  </div>
                  <div class="text-xs text-gray-400">85%, 92%</div>
                </div>
              </div>
            </div>
            
            <!-- Stats Footer (3 Columns) -->
            <div class="grid grid-cols-3 gap-4 pt-3 border-t border-gray-100 text-center">
              <div>
                <div class="text-lg font-bold text-green-600">62</div>
                <div class="text-xs text-gray-500">ชุมชน</div>
              </div>
              <div>
                <div class="text-lg font-bold text-green-600">1,540</div>
                <div class="text-xs text-gray-500">สมาชิก</div>
              </div>
              <div>
                <div class="text-lg font-bold text-emerald-600">45</div>
                <div class="text-xs text-gray-500">ผลิตภัณฑ์</div>
              </div>
            </div>
            
            <div class="text-green-600 font-medium text-sm mt-4 text-center">เข้าใช้งาน →</div>
          </a>

          <!-- Bitter Melon Cluster -->
          <a href="https://bittermelon.clustersie.org" target="_blank" class="block bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-300">
            <div class="flex items-start justify-between mb-4">
              <div class="w-16 h-16 bg-gradient-to-br from-emerald-100 to-teal-100 rounded-2xl flex items-center justify-center">
                <span class="text-2xl">🥒</span>
              </div>
              <div class="text-right">
                <div class="text-xs text-gray-500 mb-1">รายได้เดือนนี้</div>
                <div class="text-lg font-bold text-green-600">฿125M</div>
              </div>
            </div>
            
            <!-- Information Section -->
            <div class="mb-4 pb-4 border-b border-gray-100">
              <h4 class="text-xl font-bold text-gray-900 mb-2">คลัสเตอร์มะระ</h4>
              <p class="text-sm text-gray-600">จัดการการผลิตและการตลาดมะระ</p>
            </div>
            
            <!-- Chart Section -->
            <div class="mb-4">
              <div class="grid grid-cols-3 gap-4">
                <!-- Bar Chart -->
                <div class="text-center">
                  <div class="flex items-end justify-center space-x-1 h-12 mb-1">
                    <div class="bg-emerald-300 w-2 rounded-t" style="height: 55%"></div>
                    <div class="bg-emerald-400 w-2 rounded-t" style="height: 70%"></div>
                    <div class="bg-emerald-500 w-2 rounded-t" style="height: 100%"></div>
                    <div class="bg-teal-400 w-2 rounded-t" style="height: 80%"></div>
                    <div class="bg-teal-300 w-2 rounded-t" style="height: 65%"></div>
                  </div>
                  <div class="text-xs text-gray-400">ผลผลิตรายเดือน</div>
                </div>
                
                <!-- Circle Chart -->
                <div class="text-center">
                  <div class="relative w-12 h-12 mx-auto mb-1">
                    <svg class="w-12 h-12 transform -rotate-90" viewBox="0 0 36 36">
                      <path class="text-gray-200" stroke="currentColor" stroke-width="3" fill="none" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="text-emerald-500" stroke="currentColor" stroke-width="3" fill="none" stroke-dasharray="78, 100" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    </svg>
                    <div class="absolute inset-0 flex items-center justify-center">
                      <span class="text-xs font-bold text-emerald-600">78%</span>
                    </div>
                  </div>
                  <div class="text-xs text-gray-400">ประสิทธิภาพการผลิต</div>
                </div>
                
                <!-- Progress Bars -->
                <div class="text-center">
                  <div class="space-y-1 mb-1">
                    <div>
                      <div class="text-xs text-gray-500 mb-1">ปริมาณผลผลิต</div>
                      <div class="w-full bg-gray-200 rounded-full h-1">
                        <div class="bg-emerald-500 h-1 rounded-full" style="width: 78%"></div>
                      </div>
                    </div>
                    <div>
                      <div class="text-xs text-gray-500 mb-1">คุณภาพสินค้า</div>
                      <div class="w-full bg-gray-200 rounded-full h-1">
                        <div class="bg-teal-500 h-1 rounded-full" style="width: 85%"></div>
                      </div>
                    </div>
                  </div>
                  <div class="text-xs text-gray-400">78%, 85%</div>
                </div>
              </div>
            </div>
            
            <!-- Stats Footer (3 Columns) -->
            <div class="grid grid-cols-3 gap-4 pt-3 border-t border-gray-100 text-center">
              <div>
                <div class="text-lg font-bold text-emerald-600">28</div>
                <div class="text-xs text-gray-500">ชุมชน</div>
              </div>
              <div>
                <div class="text-lg font-bold text-emerald-600">720</div>
                <div class="text-xs text-gray-500">สมาชิก</div>
              </div>
              <div>
                <div class="text-lg font-bold text-teal-600">18</div>
                <div class="text-xs text-gray-500">ผลิตภัณฑ์</div>
              </div>
            </div>
            
            <div class="text-emerald-600 font-medium text-sm mt-4 text-center">เข้าใช้งาน →</div>
          </a>

          <!-- Halal Cluster -->
          <a href="https://halal.clustersie.org" target="_blank" class="block bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-300">
            <div class="flex items-start justify-between mb-4">
              <div class="w-16 h-16 bg-gradient-to-br from-indigo-100 to-purple-100 rounded-2xl flex items-center justify-center">
                <span class="text-2xl">🥘</span>
              </div>
              <div class="text-right">
                <div class="text-xs text-gray-500 mb-1">รายได้เดือนนี้</div>
                <div class="text-lg font-bold text-green-600">฿198M</div>
              </div>
            </div>
            
            <!-- Information Section -->
            <div class="mb-4 pb-4 border-b border-gray-100">
              <h4 class="text-xl font-bold text-gray-900 mb-2">คลัสเตอร์ฮาลาล</h4>
              <p class="text-sm text-gray-600">ระบบจัดการผลิตภัณฑ์ฮาลาล</p>
            </div>
            
            <!-- Chart Section -->
            <div class="mb-4">
              <div class="grid grid-cols-3 gap-4">
                <!-- Bar Chart -->
                <div class="text-center">
                  <div class="flex items-end justify-center space-x-1 h-12 mb-1">
                    <div class="bg-indigo-300 w-2 rounded-t" style="height: 65%"></div>
                    <div class="bg-indigo-400 w-2 rounded-t" style="height: 75%"></div>
                    <div class="bg-indigo-500 w-2 rounded-t" style="height: 100%"></div>
                    <div class="bg-purple-400 w-2 rounded-t" style="height: 85%"></div>
                    <div class="bg-purple-300 w-2 rounded-t" style="height: 70%"></div>
                  </div>
                  <div class="text-xs text-gray-400">ผลผลิตรายเดือน</div>
                </div>
                
                <!-- Circle Chart -->
                <div class="text-center">
                  <div class="relative w-12 h-12 mx-auto mb-1">
                    <svg class="w-12 h-12 transform -rotate-90" viewBox="0 0 36 36">
                      <path class="text-gray-200" stroke="currentColor" stroke-width="3" fill="none" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="text-indigo-500" stroke="currentColor" stroke-width="3" fill="none" stroke-dasharray="85, 100" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    </svg>
                    <div class="absolute inset-0 flex items-center justify-center">
                      <span class="text-xs font-bold text-indigo-600">85%</span>
                    </div>
                  </div>
                  <div class="text-xs text-gray-400">ประสิทธิภาพการผลิต</div>
                </div>
                
                <!-- Progress Bars -->
                <div class="text-center">
                  <div class="space-y-1 mb-1">
                    <div>
                      <div class="text-xs text-gray-500 mb-1">ปริมาณผลผลิต</div>
                      <div class="w-full bg-gray-200 rounded-full h-1">
                        <div class="bg-indigo-500 h-1 rounded-full" style="width: 85%"></div>
                      </div>
                    </div>
                    <div>
                      <div class="text-xs text-gray-500 mb-1">คุณภาพสินค้า</div>
                      <div class="w-full bg-gray-200 rounded-full h-1">
                        <div class="bg-purple-500 h-1 rounded-full" style="width: 100%"></div>
                      </div>
                    </div>
                  </div>
                  <div class="text-xs text-gray-400">85%, 100%</div>
                </div>
              </div>
            </div>
            
            <!-- Stats Footer (3 Columns) -->
            <div class="grid grid-cols-3 gap-4 pt-3 border-t border-gray-100 text-center">
              <div>
                <div class="text-lg font-bold text-indigo-600">52</div>
                <div class="text-xs text-gray-500">ชุมชน</div>
              </div>
              <div>
                <div class="text-lg font-bold text-indigo-600">1,150</div>
                <div class="text-xs text-gray-500">สมาชิก</div>
              </div>
              <div>
                <div class="text-lg font-bold text-purple-600">100%</div>
                <div class="text-xs text-gray-500">ใบรับรอง</div>
              </div>
            </div>
            
            <div class="text-indigo-600 font-medium text-sm mt-4 text-center">เข้าใช้งาน →</div>
          </a>

          <!-- Mulberry Cluster -->
          <a href="https://mulberry.clustersie.org" target="_blank" class="block bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-300">
            <div class="flex items-start justify-between mb-4">
              <div class="w-16 h-16 bg-gradient-to-br from-purple-100 to-pink-100 rounded-2xl flex items-center justify-center">
                <span class="text-2xl">🫐</span>
              </div>
              <div class="text-right">
                <div class="text-xs text-gray-500 mb-1">รายได้เดือนนี้</div>
                <div class="text-lg font-bold text-green-600">฿158M</div>
              </div>
            </div>
            
            <!-- Information Section -->
            <div class="mb-4 pb-4 border-b border-gray-100">
              <h4 class="text-xl font-bold text-gray-900 mb-2">คลัสเตอร์หม่อนไหม</h4>
              <p class="text-sm text-gray-600">จัดการการเพาะปลูกหม่อนและเลี้ยงไหม</p>
            </div>
            
            <!-- Chart Section -->
            <div class="mb-4">
              <div class="grid grid-cols-3 gap-4">
                <!-- Bar Chart -->
                <div class="text-center">
                  <div class="flex items-end justify-center space-x-1 h-12 mb-1">
                    <div class="bg-purple-300 w-2 rounded-t" style="height: 60%"></div>
                    <div class="bg-purple-400 w-2 rounded-t" style="height: 78%"></div>
                    <div class="bg-purple-500 w-2 rounded-t" style="height: 100%"></div>
                    <div class="bg-pink-400 w-2 rounded-t" style="height: 85%"></div>
                    <div class="bg-pink-300 w-2 rounded-t" style="height: 70%"></div>
                  </div>
                  <div class="text-xs text-gray-400">ผลผลิตรายเดือน</div>
                </div>
                
                <!-- Circle Chart -->
                <div class="text-center">
                  <div class="relative w-12 h-12 mx-auto mb-1">
                    <svg class="w-12 h-12 transform -rotate-90" viewBox="0 0 36 36">
                      <path class="text-gray-200" stroke="currentColor" stroke-width="3" fill="none" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                      <path class="text-purple-500" stroke="currentColor" stroke-width="3" fill="none" stroke-dasharray="83, 100" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                    </svg>
                    <div class="absolute inset-0 flex items-center justify-center">
                      <span class="text-xs font-bold text-purple-600">83%</span>
                    </div>
                  </div>
                  <div class="text-xs text-gray-400">ประสิทธิภาพการผลิต</div>
                </div>
                
                <!-- Progress Bars -->
                <div class="text-center">
                  <div class="space-y-1 mb-1">
                    <div>
                      <div class="text-xs text-gray-500 mb-1">ปริมาณผลผลิต</div>
                      <div class="w-full bg-gray-200 rounded-full h-1">
                        <div class="bg-purple-500 h-1 rounded-full" style="width: 83%"></div>
                      </div>
                    </div>
                    <div>
                      <div class="text-xs text-gray-500 mb-1">คุณภาพสินค้า</div>
                      <div class="w-full bg-gray-200 rounded-full h-1">
                        <div class="bg-pink-500 h-1 rounded-full" style="width: 90%"></div>
                      </div>
                    </div>
                  </div>
                  <div class="text-xs text-gray-400">83%, 90%</div>
                </div>
              </div>
            </div>
            
            <!-- Stats Footer (3 Columns) -->
            <div class="grid grid-cols-3 gap-4 pt-3 border-t border-gray-100 text-center">
              <div>
                <div class="text-lg font-bold text-purple-600">31</div>
                <div class="text-xs text-gray-500">ชุมชน</div>
              </div>
              <div>
                <div class="text-lg font-bold text-purple-600">680</div>
                <div class="text-xs text-gray-500">สมาชิก</div>
              </div>
              <div>
                <div class="text-lg font-bold text-pink-600">15</div>
                <div class="text-xs text-gray-500">ผลิตภัณฑ์</div>
              </div>
            </div>
            
            <div class="text-purple-600 font-medium text-sm mt-4 text-center">เข้าใช้งาน →</div>
          </a>
        </div>
        
        <div class="text-center mt-8">
          <button class="bg-green-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors">
            ดูรายงานทั้งหมด
          </button>
        </div>
      </div>
    </section>


    <!-- Meeting Calendar Section -->
    <section id="contact" class="py-16 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-12">
          <h3 class="text-4xl font-bold text-gray-900 mb-4">ตารางการประชุม</h3>
          <p class="text-lg text-gray-600">กำหนดการประชุมและกิจกรรมสำคัญของแต่ละคลัสเตอร์</p>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <!-- Calendar Widget -->
          <div class="lg:col-span-2">
            <div class="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
              <div class="flex justify-between items-center mb-6">
                <h4 class="text-2xl font-bold text-gray-900">พฤศจิกายน 2025</h4>
                <div class="flex space-x-2">
                  <button class="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
                    </svg>
                  </button>
                  <button class="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                    </svg>
                  </button>
                </div>
              </div>
              
              <!-- Calendar Grid -->
              <div class="grid grid-cols-7 gap-2 mb-4">
                <div class="text-center text-sm font-medium text-gray-500 py-2">อา</div>
                <div class="text-center text-sm font-medium text-gray-500 py-2">จ</div>
                <div class="text-center text-sm font-medium text-gray-500 py-2">อ</div>
                <div class="text-center text-sm font-medium text-gray-500 py-2">พ</div>
                <div class="text-center text-sm font-medium text-gray-500 py-2">พฤ</div>
                <div class="text-center text-sm font-medium text-gray-500 py-2">ศ</div>
                <div class="text-center text-sm font-medium text-gray-500 py-2">ส</div>
                
                <!-- Calendar Days -->
                <div class="text-center py-2 text-gray-400">27</div>
                <div class="text-center py-2 text-gray-400">28</div>
                <div class="text-center py-2 text-gray-400">29</div>
                <div class="text-center py-2 text-gray-400">30</div>
                <div class="text-center py-2 text-gray-400">31</div>
                <div class="text-center py-2 text-gray-900 bg-gray-100 rounded-lg">1</div>
                <div class="text-center py-2 text-gray-900">2</div>
                
                <div class="text-center py-2 text-gray-900">3</div>
                <div class="text-center py-2 text-gray-900">4</div>
                <div class="text-center py-2 text-gray-900 relative">
                  5
                  <div class="w-2 h-2 bg-blue-500 rounded-full absolute top-1 right-1"></div>
                </div>
                <div class="text-center py-2 text-gray-900">6</div>
                <div class="text-center py-2 text-gray-900">7</div>
                <div class="text-center py-2 text-gray-900 relative">
                  8
                  <div class="w-2 h-2 bg-green-500 rounded-full absolute top-1 right-1"></div>
                </div>
                <div class="text-center py-2 text-gray-900">9</div>
                
                <div class="text-center py-2 text-gray-900">10</div>
                <div class="text-center py-2 text-gray-900">11</div>
                <div class="text-center py-2 text-gray-900 relative">
                  12
                  <div class="w-2 h-2 bg-purple-500 rounded-full absolute top-1 right-1"></div>
                </div>
                <div class="text-center py-2 text-gray-900">13</div>
                <div class="text-center py-2 text-gray-900">14</div>
                <div class="text-center py-2 text-gray-900 relative">
                  15
                  <div class="w-2 h-2 bg-red-500 rounded-full absolute top-1 right-1"></div>
                </div>
                <div class="text-center py-2 text-gray-900">16</div>
                
                <div class="text-center py-2 text-gray-900">17</div>
                <div class="text-center py-2 text-gray-900">18</div>
                <div class="text-center py-2 text-gray-900">19</div>
                <div class="text-center py-2 text-gray-900">20</div>
                <div class="text-center py-2 text-gray-900">21</div>
                <div class="text-center py-2 text-white bg-green-600 rounded-lg font-semibold">22</div>
                <div class="text-center py-2 text-gray-900">23</div>
                
                <div class="text-center py-2 text-gray-900 relative">
                  24
                  <div class="w-2 h-2 bg-amber-500 rounded-full absolute top-1 right-1"></div>
                </div>
                <div class="text-center py-2 text-gray-900">25</div>
                <div class="text-center py-2 text-gray-900">26</div>
                <div class="text-center py-2 text-gray-900">27</div>
                <div class="text-center py-2 text-gray-900 relative">
                  28
                  <div class="w-2 h-2 bg-indigo-500 rounded-full absolute top-1 right-1"></div>
                </div>
                <div class="text-center py-2 text-gray-900">29</div>
                <div class="text-center py-2 text-gray-900">30</div>
              </div>
            </div>
          </div>

          <!-- Upcoming Meetings -->
          <div class="space-y-6">
            <div class="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
              <h4 class="text-xl font-bold text-gray-900 mb-4">การประชุมที่กำลังจะมาถึง</h4>
              
              <div class="space-y-4">
                <!-- Meeting 1 -->
                <div class="flex items-start space-x-3 p-3 bg-blue-50 rounded-lg">
                  <div class="w-3 h-3 bg-blue-500 rounded-full mt-2"></div>
                  <div class="flex-1">
                    <h5 class="font-semibold text-gray-900">ประชุมคลัสเตอร์ประมง</h5>
                    <p class="text-sm text-gray-600">วางแผนการตลาดผลิตภัณฑ์ทะเล</p>
                    <div class="text-xs text-gray-500 mt-1">5 พ.ย. 2025 • 14:00 น.</div>
                  </div>
                </div>

                <!-- Meeting 2 -->
                <div class="flex items-start space-x-3 p-3 bg-green-50 rounded-lg">
                  <div class="w-3 h-3 bg-green-500 rounded-full mt-2"></div>
                  <div class="flex-1">
                    <h5 class="font-semibold text-gray-900">ประชุมคลัสเตอร์กาแฟ</h5>
                    <p class="text-sm text-gray-600">การพัฒนาคุณภาพเมล็ดกาแฟ</p>
                    <div class="text-xs text-gray-500 mt-1">8 พ.ย. 2025 • 09:00 น.</div>
                  </div>
                </div>

                <!-- Meeting 3 -->
                <div class="flex items-start space-x-3 p-3 bg-purple-50 rounded-lg">
                  <div class="w-3 h-3 bg-purple-500 rounded-full mt-2"></div>
                  <div class="flex-1">
                    <h5 class="font-semibold text-gray-900">ประชุมคลัสเตอร์หม่อนไหม</h5>
                    <p class="text-sm text-gray-600">อบรมเทคนิคการย้อมสีธรรมชาติ</p>
                    <div class="text-xs text-gray-500 mt-1">12 พ.ย. 2025 • 13:00 น.</div>
                  </div>
                </div>

                <!-- Meeting 4 -->
                <div class="flex items-start space-x-3 p-3 bg-red-50 rounded-lg">
                  <div class="w-3 h-3 bg-red-500 rounded-full mt-2"></div>
                  <div class="flex-1">
                    <h5 class="font-semibold text-gray-900">ประชุมใหญ่ประจำปี</h5>
                    <p class="text-sm text-gray-600">สรุปผลงานและวางแผนปี 2026</p>
                    <div class="text-xs text-gray-500 mt-1">15 พ.ย. 2025 • 10:00 น.</div>
                  </div>
                </div>

                <!-- Meeting 5 -->
                <div class="flex items-start space-x-3 p-3 bg-amber-50 rounded-lg">
                  <div class="w-3 h-3 bg-amber-500 rounded-full mt-2"></div>
                  <div class="flex-1">
                    <h5 class="font-semibold text-gray-900">ประชุมคลัสเตอร์ผลไม้</h5>
                    <p class="text-sm text-gray-600">เตรียมงานเทศกาลผลไม้</p>
                    <div class="text-xs text-gray-500 mt-1">24 พ.ย. 2025 • 15:30 น.</div>
                  </div>
                </div>

                <!-- Meeting 6 -->
                <div class="flex items-start space-x-3 p-3 bg-indigo-50 rounded-lg">
                  <div class="w-3 h-3 bg-indigo-500 rounded-full mt-2"></div>
                  <div class="flex-1">
                    <h5 class="font-semibold text-gray-900">ประชุมคลัสเตอร์ฮาลาล</h5>
                    <p class="text-sm text-gray-600">การขยายตลาดผลิตภัณฑ์ฮาลาล</p>
                    <div class="text-xs text-gray-500 mt-1">28 พ.ย. 2025 • 11:00 น.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center mt-8">
          <button class="bg-green-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors">
            ดูปฏิทินทั้งหมด
          </button>
        </div>
      </div>
    </section>

    <!-- News Detail Modal -->
    <Teleport to="body">
      <Transition name="news-modal">
        <div v-if="isNewsModalOpen && selectedNews" class="fixed inset-0 z-[9999] flex items-center justify-center" @click.self="closeNewsModal">
          <!-- Backdrop -->
          <div class="absolute inset-0 bg-black/70 backdrop-blur-sm" @click="closeNewsModal"></div>
          
          <!-- Modal Content -->
          <div class="relative w-full max-w-4xl max-h-[90vh] mx-4 bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col z-10">
            <!-- Close Button -->
            <button @click="closeNewsModal" class="absolute top-4 right-4 z-20 w-10 h-10 bg-black/50 hover:bg-black/70 text-white rounded-full flex items-center justify-center transition-colors">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
            </button>
            
            <!-- YouTube Video Embed -->
            <div class="relative w-full aspect-video bg-black flex-shrink-0">
              <iframe 
                :src="'https://www.youtube.com/embed/' + selectedNews.youtubeId + '?autoplay=1&rel=0'" 
                class="absolute inset-0 w-full h-full" 
                frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                allowfullscreen
              ></iframe>
            </div>
            
            <!-- Content -->
            <div class="p-6 overflow-y-auto">
              <h2 class="text-xl md:text-2xl font-bold text-gray-900 mb-3 leading-snug">{{ selectedNews.title }}</h2>
              <div class="flex items-center gap-4 mb-4">
                <span class="text-sm text-gray-500">📅 {{ selectedNews.date }}</span>
                <a :href="selectedNews.youtube" target="_blank" rel="noopener" class="inline-flex items-center gap-1.5 text-sm text-red-600 hover:text-red-700 font-medium">
                  <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
                  ดูบน YouTube
                </a>
              </div>
              <p class="text-gray-600 leading-relaxed">{{ selectedNews.description }}</p>
            </div>
          </div>
        </div>
      </Transition>
    </Teleport>

    <!-- Article Detail Modal -->
    <ArticleDetailModal 
      :isOpen="isArticleModalOpen" 
      :article="selectedArticle" 
      @close="closeArticleModal" 
    />

    <!-- Footer Component -->
    <SiteFooter />
  </div>
</template>

<script setup>
import SiteHeader from '~/layouts/theme/custom/clustersie/components/SiteHeader.vue'
import SiteFooter from '~/layouts/theme/custom/clustersie/components/SiteFooter.vue'
import SiteSelector from '~/layouts/theme/custom/clustersie/components/SiteSelector.vue'
import MobileMenu from '~/layouts/theme/custom/clustersie/components/MobileMenu.vue'
import CountdownTimer from '~/layouts/theme/custom/clustersie/components/CountdownTimer.vue'
import NotifyForm from '~/layouts/theme/custom/clustersie/components/NotifyForm.vue'
import SocialLinks from '~/layouts/theme/custom/clustersie/components/SocialLinks.vue'
import ArticleDetailModal from '~/layouts/theme/custom/clustersie/components/ArticleDetailModal.vue'
import EbookModal from '~/layouts/theme/custom/clustersie/components/EbookModal.vue'
import { articlesData, categoryColorMap } from '~/layouts/theme/custom/clustersie/sites/data/articlesData.js'
import { productSets, formatPrice } from '~/layouts/theme/custom/clustersie/sites/data/productsData.js'
import { newsData } from '~/layouts/theme/custom/clustersie/sites/data/newsData.js'
import { onMounted, onUnmounted, ref, nextTick, computed } from 'vue'
import { useNuxtApp } from '#app'

// Define props to receive theme data from parent
const props = defineProps({
  theme: {
    type: Object,
    default: () => ({})
  }
})

// Mobile menu state
const isMobileMenuOpen = ref(false)
const activeSection = ref('home')

// Contact modal state
const isContactModalOpen = ref(false)

// Login modal state  
const isLoginModalOpen = ref(false)

// News detail modal state
const isNewsModalOpen = ref(false)
const selectedNews = ref(null)

// Article detail modal state
const isArticleModalOpen = ref(false)
const selectedArticle = ref(null)

// Ebook state
const isEbookModalOpen = ref(false)
const ebookPages = ref([
  'https://s6.imgcdn.dev/Y7SCgn.png',
  'https://s6.imgcdn.dev/Y7SnMq.png',
  'https://s6.imgcdn.dev/Y7SszB.png',
  'https://s6.imgcdn.dev/Y7ScDK.png',
  'https://s6.imgcdn.dev/Y7S6fV.png',
  'https://s6.imgcdn.dev/Y7Sytu.png',
  'https://s6.imgcdn.dev/Y7SjMl.png',
  'https://s6.imgcdn.dev/Y7SYbd.png',
  'https://s6.imgcdn.dev/Y7SDGM.png',
  'https://s6.imgcdn.dev/Y7GpN0.png',
  'https://s6.imgcdn.dev/Y7GJXe.png',
  'https://s6.imgcdn.dev/Y7G8AC.png',
  'https://s6.imgcdn.dev/Y7GEyS.png',
  'https://s6.imgcdn.dev/Y7GXpH.png',
  'https://s6.imgcdn.dev/Y7GHfi.png',
  'https://s6.imgcdn.dev/Y7GFl2.png',
  'https://s6.imgcdn.dev/Y7Gq68.png',
  'https://s6.imgcdn.dev/Y7Geby.png',
  'https://s6.imgcdn.dev/Y7GbB9.png',
  'https://s6.imgcdn.dev/Y7GLND.png',
  'https://s6.imgcdn.dev/Y7GdXT.png',
  'https://s6.imgcdn.dev/Y7GW2t.png',
  'https://s6.imgcdn.dev/Y7Gtyw.png',
  'https://s6.imgcdn.dev/Y7GVpa.png',
  'https://s6.imgcdn.dev/Y7GRVL.png',
  'https://s6.imgcdn.dev/Y7G9lu.png',
  'https://s6.imgcdn.dev/Y7GZ6B.png',
  'https://s6.imgcdn.dev/Y7G2BN.png',
  'https://s6.imgcdn.dev/Y7GALq.png'
])

// Gallery - hardcoded R2 images (no API, no dependencies)
const galleryImages = ref([
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398893_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398894_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398895_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398896_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398897_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398898_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398899_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398900_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398901_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398902_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398903_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398904_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398905_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398906_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398907_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398908_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398909_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398910_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398911_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398912_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398914_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398915_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398916_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398917(1).jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398918_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398919_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398920_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398921_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398922_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398923_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398924_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398925_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398926_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398927_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398928_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398929_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398930_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398931_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398932_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398933_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398934_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398935_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398936_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398937_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398938_0.jpg',
  'https://pub-aebc7efff90442679e94467343a2bb00.r2.dev/gallery/398939_0.jpg',
])
const isGalleryModalOpen = ref(false)
const galleryActiveIndex = ref(0)

const openGalleryModal = (idx) => {
  galleryActiveIndex.value = idx
  isGalleryModalOpen.value = true
  document.body.style.overflow = 'hidden'
}

const closeGalleryModal = () => {
  isGalleryModalOpen.value = false
  document.body.style.overflow = ''
}

const openNewsModal = (item) => {
  selectedNews.value = item
  isNewsModalOpen.value = true
  document.body.style.overflow = 'hidden'
}

const closeNewsModal = () => {
  isNewsModalOpen.value = false
  selectedNews.value = null
  document.body.style.overflow = ''
}

const openArticleModal = (article) => {
  selectedArticle.value = article
  isArticleModalOpen.value = true
  document.body.style.overflow = 'hidden'
}

const closeArticleModal = () => {
  isArticleModalOpen.value = false
  selectedArticle.value = null
  document.body.style.overflow = ''
}

// Slider state
const currentSlideIndex = ref(0)
const totalSlides = 3
let slideInterval = null

// Clusters data
const { $DSS } = useNuxtApp()
const clusters = ref([])
const clustersLoading = ref(true)

// Cluster mapping with URLs and icons
const clusterConfig = {
  'กาแฟ': {
    url: 'https://coffee.clustersie.org',
    icon: '☕',
    gradient: 'from-amber-100 to-orange-100',
    name: 'คลัสเตอร์กาแฟ',
    description: 'ระบบจัดการธุรกิจกาแฟครบวงจร',
    colors: {
      primary: 'amber',
      secondary: 'orange'
    }
  },
  'ประมง': {
    url: 'https://fisheries.clustersie.org',
    icon: '🐟',
    gradient: 'from-blue-100 to-cyan-100',
    name: 'คลัสเตอร์ประมง',
    description: 'ระบบจัดการธุรกิจประมงครบวงจร',
    colors: {
      primary: 'blue',
      secondary: 'cyan'
    }
  },
  'ผลไม้': {
    url: 'https://fruit.clustersie.org',
    icon: '🍎',
    gradient: 'from-orange-100 to-yellow-100',
    name: 'คลัสเตอร์ผลไม้',
    description: 'ระบบจัดการธุรกิจผลไม้ครบวงจร',
    colors: {
      primary: 'orange',
      secondary: 'yellow'
    }
  },
  'มะระ': {
    url: 'https://bittermelon.clustersie.org',
    icon: '🥒',
    gradient: 'from-emerald-100 to-green-100',
    name: 'คลัสเตอร์มะระ',
    description: 'ระบบจัดการธุรกิจมะระครบวงจร',
    colors: {
      primary: 'emerald',
      secondary: 'green'
    }
  },
  'ฮาลาล': {
    url: 'https://halal.clustersie.org',
    icon: '🌙',
    gradient: 'from-emerald-100 to-teal-100',
    name: 'คลัสเตอร์ฮาลาล',
    description: 'ระบบจัดการธุรกิจฮาลาลครบวงจร',
    colors: {
      primary: 'emerald',
      secondary: 'teal'
    }
  },
  'หม่อน': {
    url: 'https://mulberry.clustersie.org',
    icon: '🍇',
    gradient: 'from-purple-100 to-pink-100',
    name: 'คลัสเตอร์หม่อน',
    description: 'ระบบจัดการธุรกิจหม่อนครบวงจร',
    colors: {
      primary: 'purple',
      secondary: 'pink'
    }
  }
}

// Fetch clusters data from API
const fetchClusters = async () => {
  try {
    clustersLoading.value = true
    const response = await $DSS('clusters')
    
    if (response && response.success && Array.isArray(response.data)) {
      clusters.value = response.data
      console.log('Fetched clusters:', clusters.value)
    } else {
      console.error('Failed to fetch clusters:', response)
    }
  } catch (error) {
    console.error('Error fetching clusters:', error)
  } finally {
    clustersLoading.value = false
  }
}

// Helper function to format currency
const formatCurrency = (amount) => {
  if (!amount) return '฿0'
  
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount
  
  if (numAmount >= 1000000) {
    return `฿${(numAmount / 1000000).toFixed(1)}M`
  } else if (numAmount >= 1000) {
    return `฿${(numAmount / 1000).toFixed(0)}K`
  }
  return `฿${numAmount.toLocaleString()}`
}

// Helper function to format number
const formatNumber = (num) => {
  if (!num) return '0'
  return num.toLocaleString()
}

// Get cluster config by name
const getClusterConfig = (clusterName) => {
  // Try exact match first
  if (clusterConfig[clusterName]) {
    return clusterConfig[clusterName]
  }
  
  // Try partial match
  for (const [key, config] of Object.entries(clusterConfig)) {
    if (clusterName.includes(key) || key.includes(clusterName)) {
      return config
    }
  }
  
  // Default config
  return {
    url: '#',
    icon: '📦',
    gradient: 'from-gray-100 to-gray-200',
    name: clusterName,
    description: 'ระบบจัดการธุรกิจครบวงจร',
    colors: {
      primary: 'gray',
      secondary: 'gray'
    }
  }
}

// Log received theme for debugging
console.log('MainSite received theme:', props.theme)

// Handle events from header component
const handleToggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value
}

const handleOpenContactModal = () => {
  isContactModalOpen.value = true
}

const handleOpenLoginModal = () => {
  isLoginModalOpen.value = true
}

const handleSmoothScrollTo = (target, event) => {
  smoothScrollTo(target, event)
}

// Slider methods
const showSlide = (index) => {
  currentSlideIndex.value = index
  currentSlide = index
  
  // Update DOM classes
  const slides = document.querySelectorAll('.slide')
  const dots = document.querySelectorAll('.dot')
  
  slides.forEach((slide, i) => {
    if (i === index) {
      slide.classList.add('active')
    } else {
      slide.classList.remove('active')
    }
  })
}

const handleNextSlide = () => {
  const nextIndex = (currentSlideIndex.value + 1) % totalSlides
  showSlide(nextIndex)
  resetAutoSlide()
}

const handlePrevSlide = () => {
  const prevIndex = (currentSlideIndex.value - 1 + totalSlides) % totalSlides
  showSlide(prevIndex)
  resetAutoSlide()
}

const goToSlide = (index) => {
  showSlide(index)
  resetAutoSlide()
}

const startAutoSlide = () => {
  if (slideInterval) {
    clearInterval(slideInterval)
  }
  slideInterval = setInterval(() => {
    handleNextSlide()
  }, 5000)
}

const stopAutoSlide = () => {
  if (slideInterval) {
    clearInterval(slideInterval)
    slideInterval = null
  }
}

const resetAutoSlide = () => {
  stopAutoSlide()
  startAutoSlide()
}

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value
}

const closeMobileMenu = () => {
  isMobileMenuOpen.value = false
}

// Contact modal functions
const openContactModal = () => {
  isContactModalOpen.value = true
  closeMobileMenu()
}

const closeContactModal = () => {
  isContactModalOpen.value = false
}

// Fast smooth scroll function without delays
const smoothScrollTo = (targetId, event) => {
  event?.preventDefault()
  
  // Close mobile menu immediately if open
  closeMobileMenu()
  
  // Handle home section - scroll to top
  if (targetId === 'home') {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    return
  }
  
  // Handle other sections
  const target = document.getElementById(targetId)
  if (!target) {
    return
  }
  
  // Calculate offset for sticky header
  const headerHeight = 80
  const targetPosition = target.offsetTop - headerHeight
  
  // Use native smooth scroll for immediate response
  window.scrollTo({ 
    top: targetPosition, 
    behavior: 'smooth' 
  })
}



// Scroll detection for active section only
const handleScroll = () => {
  const currentScrollY = window.scrollY
  const sections = ['home', 'dashboard', 'clusters', 'products', 'articles', 'gallery', 'contact']
  const scrollPos = currentScrollY + 100 // offset for sticky header

  // Check if we're at the top of the page (home section)
  if (currentScrollY < 50) {
    activeSection.value = 'home'
    return
  }

  // Find active section based on scroll position
  for (let i = sections.length - 1; i >= 0; i--) {
    if (sections[i] === 'home') continue // Skip home as we handle it above
    
    const section = document.getElementById(sections[i])
    if (section && section.offsetTop <= scrollPos) {
      activeSection.value = sections[i]
      break
    }
  }
}

onMounted(() => {
  console.log('MainSite component mounted')
  
  // Fetch clusters data
  fetchClusters()
  
  // Initialize slider with Vue reactive state
  nextTick(() => {
    // Set initial slide
    showSlide(0)
    
    // Start auto slide
    startAutoSlide()
    
    console.log('Slider initialized with Vue reactivity')
  })
  
  // Add scroll listener
  window.addEventListener('scroll', handleScroll)
  
  // Initial check
  handleScroll()
  
  onUnmounted(() => {
    console.log('MainSite component unmounting')
    
    // Stop auto slide
    stopAutoSlide()
    
    // Remove scroll listener
    window.removeEventListener('scroll', handleScroll)
    
    console.log('MainSite cleanup completed')
  })
})
</script>

<style scoped>
/* Main site specific styles */
.bg-gradient-to-br {
  background: linear-gradient(to bottom right, #f0fdf4, #eff6ff);
}

/* Slider Styles */
.slide-container {
  position: relative;
  height: 32rem; /* 128 in Tailwind - increased from 24rem */
  overflow: hidden;
}

.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transform: translateX(100%);
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide.active {
  opacity: 1;
  transform: translateX(0);
}

.slide img {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.dot {
  cursor: pointer;
  transition: all 0.3s ease;
}

.dot:hover {
  opacity: 80% !important;
  transform: scale(1.2);
}

.dot.active {
  opacity: 100% !important;
  transform: scale(1.3);
}

/* Navigation buttons */
button[id$="Btn"] {
  backdrop-filter: blur(4px);
}

button[id$="Btn"]:hover {
  backdrop-filter: blur(8px);
  transform: scale(1.1);
}

/* Mobile Menu Animations */
.mobile-menu-enter-active,
.mobile-menu-leave-active {
  transition: all 0.3s ease-in-out;
}

.mobile-menu-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.mobile-menu-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* Mobile menu items */
.mobile-menu-item {
  transition: all 0.2s ease-in-out;
}

.mobile-menu-item:hover {
  transform: translateX(4px);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .slide h2 {
    font-size: 2.5rem;
  }
  
  .slide p {
    font-size: 1rem;
  }
  
  /* Hide desktop menu items on mobile */
  .desktop-menu {
    display: none;
  }
}

@media (max-width: 640px) {
  .slide h2 {
    font-size: 2rem;
  }
  
  .slide p {
    font-size: 0.875rem;
  }
  
  /* Adjust mobile menu for smaller screens */
  .mobile-menu-panel {
    max-height: 70vh;
    overflow-y: auto;
  }
}

/* Smooth scroll for one-page navigation */
html {
  scroll-behavior: smooth;
}

/* Adjust scroll position for fixed header */
section {
  scroll-margin-top: 80px;
}

/* Network animation */
@keyframes networkPulse {
  0%, 100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.2);
  }
}

@keyframes connectionFlow {
  0% {
    stroke-dasharray: 5, 5;
    stroke-dashoffset: 10;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes networkConnectFlow {
  0% {
    stroke-dashoffset: 10;
    opacity: 0.1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    stroke-dashoffset: 0;
    opacity: 0.1;
  }
}

@keyframes centralPulse {
  0%, 100% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.8;
  }
}

.network-node {
  filter: drop-shadow(0 0 3px rgba(76, 175, 80, 0.5));
}

.network-line {
  animation: connectionFlow 2s linear infinite;
}

.connection-line {
  animation: networkConnectFlow 4s ease-in-out infinite;
  filter: drop-shadow(0 0 2px rgba(165, 214, 167, 0.3));
}

.central-connection {
  animation: centralPulse 3s ease-in-out infinite;
  filter: drop-shadow(0 0 3px rgba(129, 199, 132, 0.4));
}

/* Solar System specific styles */
.solar-sun {
  filter: drop-shadow(0 0 6px rgba(255, 213, 79, 0.4));
}

.inner-orbit circle {
  filter: drop-shadow(0 0 3px rgba(76, 175, 80, 0.3));
}

.middle-orbit circle {
  filter: drop-shadow(0 0 3px rgba(255, 152, 0, 0.25));
}

.outer-orbit circle {
  filter: drop-shadow(0 0 4px rgba(255, 87, 34, 0.2));
}

.asteroid-belt circle {
  filter: drop-shadow(0 0 1px rgba(189, 189, 189, 0.15));
}

/* News Modal Transition */
.news-modal-enter-active,
.news-modal-leave-active {
  transition: opacity 0.3s ease;
}
.news-modal-enter-active .relative {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.news-modal-leave-active .relative {
  transition: transform 0.2s ease, opacity 0.2s ease;
}
.news-modal-enter-from,
.news-modal-leave-to {
  opacity: 0;
}
.news-modal-enter-from .relative {
  transform: scale(0.95) translateY(20px);
  opacity: 0;
}
.news-modal-leave-to .relative {
  transform: scale(0.95) translateY(20px);
  opacity: 0;
}

/* Corner Ribbon Styles */
.corner-ribbon {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  overflow: hidden;
  width: 120px;
  height: 120px;
  pointer-events: none;
}

.corner-ribbon span {
  position: absolute;
  display: block;
  width: 160px;
  padding: 8px 0;
  background: linear-gradient(135deg, #dc2626 0%, #991b1b 100%);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 1px;
  top: 24px;
  right: -40px;
  transform: rotate(45deg);
  transform-origin: center;
}

.corner-ribbon-small {
  width: 100px;
  height: 100px;
}

.corner-ribbon-small span {
  width: 140px;
  padding: 6px 0;
  font-size: 10px;
  top: 20px;
  right: -30px;
}

/* Add animation on hover */
.group:hover .corner-ribbon span {
  background: linear-gradient(135deg, #991b1b 0%, #dc2626 100%);
}

</style>

<style>
/* Global styles for smooth scroll and fixed navigation */
html {
  scroll-behavior: smooth !important;
}

/* Ensure navigation works globally */
body {
  overflow-x: hidden;
  position: relative;
}

/* Fixed navigation that transforms on scroll */
.nav-fixed {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 1000 !important;
  width: 100% !important;
  transform: translateY(-100%);
  transition: transform 0.3s ease-in-out;
}

.nav-fixed.visible {
  transform: translateY(0);
}

/* Original navigation position */
.nav-relative {
  position: relative !important;
  z-index: 999 !important;
}
</style>